import React from 'react';
import { signOut } from 'firebase/auth';
import { auth } from '../../services/firebase';
import './Header.css';

const Header: React.FC = () => {
  const handleLogout = async () => {
    try {
      await signOut(auth);
      localStorage.removeItem('authToken');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  return (
    <header className="app-header">
      <div className="header-container">
        <div className="header-left">
          <h1>🎬 Dubbing Demo</h1>
        </div>
        <div className="header-right">
          <span className="user-email">{auth.currentUser?.email}</span>
          <button onClick={handleLogout} className="logout-button">
            Logout
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;